import styled, { css } from 'styled-components';
import { Button } from 'components/atoms/button';
import { Input } from 'components/atoms/input';
import { Layout } from 'components/atoms/layout';
import {
  Caption01,
  OutlineError,
  ProductiveHeading04,
  ProductiveHeading05,
} from 'components/styles';

const { Content } = Layout;

export const Container = styled(Content)`
  display: flex;
  flex-direction: column;
  margin: var(--spacing-11);
  align-items: flex-start;
  width: 22rem;
  gap: var(--spacing-09);
`;

export const Heading = styled.div`
  ${ProductiveHeading04};
  font-weight: var(--heading-6-weight);
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
`;

export const SubHeading = styled.div`
  ${ProductiveHeading05};
`;

export const EmailSentToDetail = styled.div`
  display: flex;
  gap: var(--spacing-04);
`;

export const Prompt = styled.div`
  ${Caption01};
  color: var(--gray-70);
`;

export const EmailTextHolder = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EmailText = styled.span`
  font-weight: var(--heading-8-weight);
`;

export const OTPContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-03);
`;

export const OTPInput = styled(Input)<{ isError: boolean }>`
  font-weight: 400;
  height: 3.5rem;
  width: 100%;
  font-size: var(--heading-4-size);
  line-height: var(--heading-7-line-height);
  letter-spacing: var(--spacing-02);
  ${({ isError }) =>
    isError &&
    css`
      ${OutlineError};
    `};
`;

export const InputError = styled.span`
  color: var(--error-color);
  font-size: var(--font-size-sm);
  width: 100%;
  display: flex;
`;

export const SignInButton = styled(Button)`
  width: 100%;
  height: 3.5rem;
`;

export const ResendButton = styled(Button)`
  color: var(--blue-70);
  font-size: var(--font-size-sm);
  padding: 0;
  :hover {
    background-color: transparent;
  }
`;

export const Footer = styled.div`
  width: 100%;
  border-top: solid 1px var(--gray-20);
`;
